export interface EasterEggKeyword {
  keyword: string;
  trigger: string;
  description?: string;
}

export class EasterEggKeywords {
  static readonly KEYWORDS: EasterEggKeyword[] = [
    { keyword: 'hack', trigger: 'hack', description: 'Enter hacker mode' },
    { keyword: 'hacker', trigger: 'hacker', description: 'Enter hacker mode' },
    { keyword: 'hackerman', trigger: 'hackerman', description: 'Enter hacker mode' },
    { keyword: 'matrix', trigger: 'matrix', description: 'Enter hacker mode' },
    { keyword: 'sudo', trigger: 'sudo', description: 'Enter hacker mode' },
    { keyword: 'root', trigger: 'root', description: 'Enter hacker mode' }
  ];

  static makeClickable(text: string, keyword: string, trigger?: string): string {
    const actualTrigger = trigger || keyword;
    const clickableKeyword = `<span 
      class="easter-egg-keyword" 
      onclick="window.terminal.executeSelectedCommand('${actualTrigger}')"
    >${keyword}</span>`;
    
    return text.replace(new RegExp(`\\b${keyword}\\b`, 'gi'), clickableKeyword);
  }

  static wrapKeywords(text: string, keywords: string[] = ['hack']): string {
    let wrappedText = text;
    
    keywords.forEach(keyword => {
      const keywordData = this.KEYWORDS.find(k => k.keyword.toLowerCase() === keyword.toLowerCase());
      if (keywordData) {
        wrappedText = this.makeClickable(wrappedText, keyword, keywordData.trigger);
      }
    });
    
    return wrappedText;
  }

  static generateHints(keywords: string[], title: string = 'Try These Words'): string {
    if (keywords.length === 0) return '';
    
    const hints = keywords.map(keyword => {
      const keywordData = this.KEYWORDS.find(k => k.keyword.toLowerCase() === keyword.toLowerCase());
      const trigger = keywordData?.trigger || keyword;
      const description = keywordData?.description || `Try saying "${keyword}"`;
      
      return `
        <span 
          class="easter-egg-hint" 
          onclick="window.terminal.executeSelectedCommand('${trigger}')"
          title="${description}"
        >
          ${keyword}
        </span>`;
    }).join('');
    
    return `
      <div class="easter-egg-hints">
        <span class="hints-title">${title}:</span>
        <div class="hint-keywords">
          ${hints}
        </div>
      </div>
    `;
  }
}